import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

/**
 * Higgsfield-style ultra-minimal header.
 * Just a brand wordmark (left) + single champagne pill CTA (right).
 * Transparent over hero, fades to solid warm-black on scroll.
 */
export const CinematicHeader = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -30, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 1, delay: 0.3 }}
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled ? "bg-[#0D0D0D]/85 backdrop-blur-md py-4" : "py-6 md:py-8"
      }`}
    >
      <div className="container-premium flex items-center justify-between">
        <Link to="/" className="group">
          <div className="text-white leading-none">
            <div className="font-display italic text-2xl md:text-[26px] font-normal tracking-tight">
              Beach Escape
            </div>
            <div className="text-[9px] uppercase tracking-[0.4em] text-white/60 mt-1">
              Indialantic · Florida
            </div>
          </div>
        </Link>

        <Link
          to="/contact"
          data-testid="cinematic-header-cta"
          className="group inline-flex items-center gap-2 border border-[#C4A570] text-[#C4A570] hover:bg-[#C4A570] hover:text-[#0D0D0D] transition-colors duration-500 px-6 py-2.5 rounded-full text-[11px] uppercase tracking-[0.35em]"
        >
          Request a Tour
        </Link>
      </div>
    </motion.header>
  );
};

export default CinematicHeader;
